var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"type":"number","prefix":_vm.currency,"step":"0.01","min":"0","value":_vm.userInput},on:{"input":_vm.onInput}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }